import React from 'react';
import { css, cx } from 'emotion';

const rightSidebarWidthStyle = css`
  grid-area: info;
  padding: 2rem 1.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    height: unset;
    background-color: unset;
    width: unset;
    padding: 0;
  }
`;
const hasChildContainerStyle = css`
  background-color: var(--silver);
`;

export const RightSidebar = props => {
  const { children } = props;
  return <aside className={cx(rightSidebarWidthStyle, children && hasChildContainerStyle)}>{children}</aside>;
};
